<template>
    <div id="about">
        <div class="div-block-4"></div>
        <div data-collapse="medium" data-animation="default" data-duration="400" class="header-navigation fixed w-nav">
            <NetworkStatus/>
            <HeaderMenu/>
        </div>

        <div>
            <div class="section section-color center">
                <div class="w-container" style="padding:50px 0 0 0">
                    <h1 class="key-number">LocalScale for Dentists &amp; Orthodontists</h1>
                </div>
            </div>

            <div class="center" style="margin:20px 30px">
                <div class="industry-container">
                    <div class="industry-text">
                        <p style="font-size: 18px;font-weight:bold">Unlock the power of precision advertising with LocalScale, where your dental practice becomes the talk of the town!</p>
                        <p>At LocalScale, we understand that for dentists and orthodontists, visibility in your local community isn't just about being seen—it's about being sought after.</p>
                        <p>Our targeted ad network lets you pinpoint potential patients by cities and zip codes, ensuring your marketing efforts resonate right where you practice.</p>
                        <p>Whether you're promoting teeth whitening services, routine check-ups, or advanced orthodontic treatments, LocalScale connects your practice to the households that value oral health the most.</p>
                        <p>Let's give your local presence a boost and fill your appointment books faster than ever!</p>
                        <div class="button-group" style="margin-top: 20px;margin-bottom: 10px;">
                            <div class="navigation-action"><a href="signup.html" class="ds-button button-small w-button">{{$t('get_started')}}</a></div>
                        </div>
                    </div>
                    <div class="industry-image">
                        <img src="images/industry-dental-and-orthondontic.png" alt="Dental And Orthondontic">
                    </div>
                </div>
            </div>

            <div style="width: 100%;background-color:#e6faf6;">
                <div class="testimonial">
                    <div class="testimonial-stars">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                        <img src="images/star.svg" loading="lazy" alt="Star">
                    </div>
                    <h3 class="testimonial-quote">“Joining LocalScale was the best decision for our dental practice. Our practice saw a surge in leads, helping us reach new patients and boosting our growth significantly.”</h3>
                    <p class="testimonial-customer">– Dr. Emily Parker, Bright Smiles Dental Clinic</p>
                </div>
            </div>

            <Plans :what_are_you_waiting_for="true"/>
        </div>

        <Footer/>
    </div>
</template>

<script>
import HeaderMenu from "../components/HeaderMenu";
import NetworkStatus from "../components/NetworkStatus.vue";
import Footer from "../components/Footer";
import Plans from "../components/Plans";

export default {
    components: {
        HeaderMenu, NetworkStatus, Footer, Plans
    }
}
</script>

<style>
body {
    font-family: Inter, sans-serif;
    background-color: #fff;
}
p {
    color: black;
    margin: 10px;
    font-size: 16px;
}
h2 {
    text-align: center;
}
a {
    text-decoration: none;
    color: #1f1f1f
}
</style>
